import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import { generalOpenToastError } from "../../../../actions/general.actions";
import InputForm from "../../../OtrosDocumentos/Components/InputFormV2";
import BasicCardWithButtons from "../../../../components/BasicCardWithButtons";
import { State } from "../../../../reducers";
import { getDataConsultaDocsVenta, getRetencionesDetectadasVentas, setFormVentas, setVentasRetencionesDetectadas, ventasOpenModalFormatos, ventasOpenModelCargarFormato } from "../../../../actions/libros/libros-ventas.actions";
import { Link } from "react-router-dom";

export const optionsLibroVentas = [{codigo_nombre: "LIBRO DE VENTAS A CONSUMIDOR FINAL", codigo: "01"}, {codigo_nombre: "LIBRO DE VENTAS A CONTRIBUYENTES", codigo: "02"}];

export default function FormularioLibroVentas (){
    const dispatch = useDispatch()
    const {datosEmisor} = useSelector((state: State) => state.catalogos)

    const defaultValue = {startDate: '', endDate: '', tipoLibro: ''}
    const [data, setData] = useState(defaultValue);
    const [errors, setErrors] = useState(defaultValue)
    
    useEffect(() => {
      dispatch(setFormVentas(data));
    }, [data]);

    const onChangeHandler = async (e: any) => {
      let {name, value} = e.target;
      const errorMessage = HandleValidationError(e);
      setData(prevData => ({
        ...prevData,
        [name]: value
      }));
      setErrors(prevData => ({
        ...prevData,
        [name]: errorMessage
      })); 
    }

    const handleOpenWarning = async () => {
      if (!validarVacios()) return;
      if (!validationData(data, errors)) return;
      // Cada consulta parte de cero: la eleccion de incluir retenciones no se recuerda
      dispatch(setVentasRetencionesDetectadas([]));
      await dispatch(getDataConsultaDocsVenta(data));

      // Contribuyentes: detectar las retenciones del 1% que aun no tienen comprobante de retencion cargado.
      // Solo se avisan junto al boton de generar; no se guarda nada hasta generar el libro.
      if (data.tipoLibro === "02") {
        const detectadas: any = await dispatch(getRetencionesDetectadasVentas(data) as any);
        dispatch(setVentasRetencionesDetectadas(detectadas ?? []));
      }
    }

    const handleOpenModalPlantillas = () => {
      dispatch(ventasOpenModelCargarFormato(true));
    }

    const validarVacios = () => {
        if (data?.startDate === ''){
            dispatch(generalOpenToastError('La fecha inicial no puede estar vacía'));
            setErrors(prevData => ({...prevData, startDate: 'La fecha inicial no puede estar vacía'}));
            return false;
        }
        if (data?.endDate === ''){
            dispatch(generalOpenToastError('La fecha final no puede estar vacía'));
            setErrors(prevData => ({...prevData, endDate: 'La fecha final no puede estar vacía'}));
            return false;
        }
        if (data?.tipoLibro === ''){
            dispatch(generalOpenToastError('El tipo de libro no puede estar vacío'));
            setErrors(prevData => ({...prevData, tipoLibro: 'El tipo de libro no puede estar vacío'}));
            return false;
        }
        return true;
    }

    const validationData = (data: any, errors: any) => {
      for (let err of Object.values(errors)) {
        if (err !== '') {
          dispatch(generalOpenToastError('Los datos de cierre contienen valores incorrectos'));
          return false;
        }
      }
      if (!fechaMayor(data?.endDate, data?.startDate)){
        dispatch(generalOpenToastError('La fecha final debe ser mayor a la fecha inicial'));
        return false;
      }
      return true;
    }

    const fechaMayor = (fecha1: string, fecha2: string) => {
        const fecha1Obj = new Date(fecha1);
        const fecha2Obj = new Date(fecha2);
        if (fecha1Obj >= fecha2Obj) return true;
        return false
    }

    const HandleValidationError = (e: any) => {
        let {name, value} = e.target
        let message = ''
        switch (name) {
          case 'startDate':
            const startDate = new Date(value);
            if (isNaN(startDate.getTime())) {
              message = 'La fecha contiene valores incorrectos'
            }
            break;
          case 'endDate':
            const endDate = new Date(value);
            if (isNaN(endDate.getTime())) {
              message = 'La fecha contiene valores incorrectos'
            }
            break;
          default:
            break;
        }
        return message;
    }

    return (
      <div className="w-layout-layout bill-section wf-layout-layout">
        <BasicCardWithButtons style={{boxShadow: 'none', padding: '0'}} title="Detalle de documento" size="l" buttons={<ButtonsCardDetalle />}>
          <div style={{ display: 'flex' }}>
            <div style={{textAlign: 'left', width: '48%'}}>
              <h1 className="m" style={{ fontWeight: '400', margin: '0'}}>Empresa</h1>
              <label>{datosEmisor?.nombre}</label>
              <label>{datosEmisor?.telefono}</label>
              <label>{datosEmisor?.complemento}</label>
            </div>
            <div style={{textAlign: 'left'}}>
              <h1 className="m" style={{ fontWeight: '400', margin: '0'}}>Correo electrónico</h1>
              <label>{datosEmisor.correo}</label>
            </div>
          </div>
          <div style={{width: '50%'}}>
            <h1 className="m">Datos de documento</h1>
            <div className='w-layout-hflex h-inputs'>
              <InputForm required name = 'startDate' label = 'Fecha inicial' type = 'date' onChange={onChangeHandler} error={errors.startDate} value={data.startDate}/>
              <InputForm required name = 'endDate' label = 'Fecha final' type = 'date' onChange={onChangeHandler} error={errors.endDate} value={data.endDate} />
            </div>
            <div className='w-layout-hflex h-inputs' style={{marginTop: '16px'}}>
              <InputForm
                onChange = {(e: any) => onChangeHandler({target: {value: e.value, name: 'tipoLibro'}})} value={data.tipoLibro} error={errors.tipoLibro}
                required keyNameText = 'codigo_nombre' keyNameValue = 'codigo' name = 'tipoLibro' placeholder = 'Seleccione una opcion' label = 'Libro de ventas a generar' type = 'select'
                options = {optionsLibroVentas} />
            </div>
          </div>
          <div style={{display: 'flex', justifyContent: 'end', marginTop: '16px', gap: '16px'}}>
            {/* PLANTILLA CONTRIBUYENTE */}
            {
              (data.tipoLibro === "02")
              &&
              <button className="button w-auto transparent" onClick={handleOpenModalPlantillas}>Cargar plantilla</button>
            }
            <button className="button w-auto" onClick={handleOpenWarning}>Consultar Libro de IVA</button>
          </div>
        </BasicCardWithButtons>
      </div>
    );
}

export const ButtonsCardDetalle = () => {
  const dispatch = useDispatch();
  
  const openDescargarFormatos = () => {
    dispatch(ventasOpenModalFormatos(true));
  }

  return (
    <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
      <Link className="button w-auto transparent" to='/mas-opciones/libro-ventas-consulta' style={{textDecoration: 'none'}}>
        <span>Consultar libros generados</span>
      </Link>
      <button className="button w-auto" onClick={openDescargarFormatos}>Descargar plantillas</button>
    </div>
  )
}